import request from '@/utils/request'
import request1 from '@/utils/request1'
import { getToken } from '../utils/auth'
// 查询未处理警报
export function queryunhanlealarm (params) {
  params.token = getToken()
  return request1({
    url: '/queryunhanlealarm',
    method: 'post',
    params
  })
}
// 处理警报
export function hanlealarm (data) {
  return request({
    url: '/hanlealarm',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 预处理警报（加入处理列表）
export function prehanlealarm (data) {
  return request({
    url: '/prehanlealarm',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询当前组织客服信息
export function queryorgpersonuser (data) {
  return request({
    url: '/queryorgpersonuser',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 指派客服处理
export function appointhanlealarm (data) {
  return request({
    url: '/appointhanlealarm',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// hid查询家庭机构
export function queryhomebyhids (data) {
  return request({
    url: '/queryhomebyhids',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// pid查询服务对象
export function queryoldpersonbypids (data) {
  return request({
    url: '/queryoldpersonbypids',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// hid查询服务对象
export function queryoldpersonbyhids (data) {
  return request({
    url: '/queryoldpersonbyhids',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 设备家庭下所有人员信息
export function queryoldpersonbyhomedid (data) {
  return request({
    url: '/queryoldpersonbyhomedid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}

export function queryoldpersonbyimei (data) {
  return request({
    url: '/queryoldpersonbyimei',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据报警id查询派单情况
export function queryalarmhandle (data) {
  return request({
    url: '/queryalarmhandle',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 通过手机号查找服务对象
export function searchpersonbyphone (data) {
  return request({
    url: '/searchpersonbyphone',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据pid，查找关联号码
export function queryphonebypid (data) {
  return request({
    url: '/queryphonebypid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据hid，查找关联号码
export function queryphonebyhid (data) {
  return request({
    url: '/queryphonebyhid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 按照事件ID查找事件信息
export function queryunhanlealarmbyalarmid (data) {
  return request({
    url: '/queryunhanlealarmbyalarmid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/handlealarm.js